import {ProcessType} from "./process-type";
import {ProcessPropertySet} from "./process-property-set";

export class ProcessLite {
    key: string;
    name: string;
    description: string;
    processType: ProcessType;
    model: string;
    publicOutputInd: boolean;
    outputName: string;
    propertySets: ProcessPropertySet[];
    processTypes: ProcessType[];
}
